import { navigate } from '@/navigations/RootNavigation';
import { useDialogBridge } from '@/hooks/useDialogBridge';

interface SignUpMessagesProps {
  isModalVisible: boolean;
  setModalVisible: (visible: boolean) => void;
  isModalErrorVisible: boolean;
  setModalErrorVisible: (visible: boolean) => void;
  email: string;
}

export default function SignUpMessages({
  isModalVisible,
  setModalVisible,
  isModalErrorVisible,
  setModalErrorVisible,
  email,
}: SignUpMessagesProps) {
  const text =
    'Ihre E-Mail-Adresse muss verifiziert werden, bevor Sie neolexon verwenden können. ' +
    'Wir haben Ihnen eine E-Mail an ' +
    JSON.stringify(email) +
    ' zur Verifizierung gesendet. ' +
    'Bitte überprüfen Sie Ihr E-Mail-Postfach.';

  const errorText =
    'Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.';

  const handleSuccessSignUp = () => {
    navigate('Login', { email });
    setModalVisible(false);
  };

  useDialogBridge(
    isModalVisible,
    () => ({
      title: 'Vielen Dank für Ihre Registrierung!',
      content: text,
      confirmAction: {
        label: 'weiter',
        onPress: () => handleSuccessSignUp(),
      },
    }),
    [text],
  );

  useDialogBridge(
    isModalErrorVisible,
    () => ({
      title: 'Fehler bei der Registrierung',
      content: errorText,
      confirmAction: {
        label: 'weiter',
        onPress: () => setModalErrorVisible(false),
      },
    }),
    [],
  );

  return null;
}
